var _circle, _circle2, _polygon, _path, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 28,
    r: 16,
    fill: "#3ddab4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.584,
    cy: 17.478,
    r: 13.449,
    fill: "#f5bc00"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3ddab4",
    points: "4.07,44 19.909,44 10.922,35.549"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b569",
    d: "M20,12c-0.239,0-0.471,0.025-0.708,0.036c-0.739,1.665-1.157,3.504-1.157,5.443 c0,7.428,6.021,13.449,13.449,13.449c1.484,0,2.907-0.25,4.242-0.693C35.929,29.502,36,28.76,36,28C36,19.163,28.837,12,20,12z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5bc00",
    points: "44.975,4.029 31.661,4.029 39.215,11.133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefault);
export default __webpack_public_path__ + "static/media/icon_default.878c5901b94953e0a0fe69f8f7146661.svg";
export { ForwardRef as ReactComponent };